/**
 * Footer Component
 * Site footer with links and copyright
 */

import { COMPANY_INFO } from '../utils/constants';

export function createFooter(): string {
  return `
    <!-- ════════════════════════════════════
         FOOTER
    ════════════════════════════════════ -->
    <footer style="background:#000000; padding:60px 0 32px; color:rgba(248,247,244,0.35);">
      <div style="max-width:1320px; margin:0 auto; padding:0 48px;">

        <!-- Footer grid -->
        <div class="ft-grid" style="display:grid; grid-template-columns:repeat(4, 1fr); gap:64px; margin-bottom:64px;">

          <!-- Column 1: About -->
          <div>
            <div style="font-family:'Cormorant Garamond',serif; font-size:12px; font-weight:600;
              letter-spacing:0.14em; color:#C9A227; margin-bottom:20px; text-transform:uppercase;">
              Arceus Wealth
            </div>
            <p style="font-size:14px; line-height:1.8; color:#888888; font-weight:300;">
              A wealth management firm that partners with exceptional individuals to grow their potential through disciplined strategy and long-term planning.
            </p>
          </div>

          <!-- Column 2: Strategy -->
          <div>
            <div style="font-family:'Cormorant Garamond',serif; font-size:12px; font-weight:600;
              letter-spacing:0.14em; color:#C9A227; margin-bottom:20px; text-transform:uppercase;">
              Strategy
            </div>
            <ul style="list-style:none; padding:0;">
              <li style="margin-bottom:12px;"><a href="#strategy" style="color:#888888; text-decoration:none; font-size:14px; transition:color 0.2s ease;">Investment Approach</a></li>
              <li style="margin-bottom:12px;"><a href="#focus-areas" style="color:#888888; text-decoration:none; font-size:14px; transition:color 0.2s ease;">Focus Sectors</a></li>
              <li style="margin-bottom:12px;"><a href="#approach" style="color:#888888; text-decoration:none; font-size:14px; transition:color 0.2s ease;">Operational Value</a></li>
            </ul>
          </div>

          <!-- Column 3: Firm -->
          <div>
            <div style="font-family:'Cormorant Garamond',serif; font-size:12px; font-weight:600;
              letter-spacing:0.14em; color:#C9A227; margin-bottom:20px; text-transform:uppercase;">
              Firm
            </div>
            <ul style="list-style:none; padding:0;">
              <li style="margin-bottom:12px;"><a href="#leadership" style="color:#888888; text-decoration:none; font-size:14px; transition:color 0.2s ease;">Leadership</a></li>
            </ul>
          </div>

          <!-- Column 4: Partnership -->
          <div>
            <div style="font-family:'Cormorant Garamond',serif; font-size:12px; font-weight:600;
              letter-spacing:0.14em; color:#C9A227; margin-bottom:20px; text-transform:uppercase;">
              Contact
            </div>
            <p style="font-size:14px; line-height:1.8; color:#888888; font-weight:300; margin-bottom:12px;">
              Founders, high-net-worth individuals, and institutional partners are welcome to reach out.
            </p>
            <a href="/contact.html" class="btn-s" style="display:inline-flex; margin-top:12px;">Contact Us</a>
          </div>

        </div>

        <!-- Bottom bar -->
        <div class="ft-bottom" style="display:flex; justify-content:space-between; align-items:center;
          padding-top:32px; border-top:1px solid rgba(201, 162, 39, 0.15);">
          <div style="font-size:12px; color:#666666;">
            &copy; 2026 Arceus Wealth. All rights reserved.
          </div>
          <div style="font-size:11px; color:#666666; letter-spacing:0.08em;">
            ${COMPANY_INFO.location}
          </div>
        </div>

      </div>
    </footer>
  `;
}

export default createFooter;
